export enum GameRewardType {
    COINS = 'coins',
    CARDS = 'cards',
    LIVES = 'lives',
}

export enum SpinWheelRewardType {
    COINS_1 = 'coins_1',
    COINS_2 = 'coins_2',
    COINS_3 = 'coins_3',

    CARDS_1 = 'cards_1',
    CARDS_2 = 'cards_2',
    CARDS_3 = 'cards_3',

    LIVES_1 = 'lives_1',
    LIVES_2 = 'lives_2',
}

export interface IPrizeWheelRewardData {
    odds: number;
    type: SpinWheelRewardType;
    value: number;
    angle: number;
}

export const PRIZE_WHEEL_REWARDS: IPrizeWheelRewardData[] = [
    { odds: 0.38, type: SpinWheelRewardType.COINS_1, value: 75, angle: 315 },
    { odds: 0.27, type: SpinWheelRewardType.COINS_2, value: 100, angle: 225 },
    { odds: 0.01, type: SpinWheelRewardType.COINS_3, value: 1000, angle: 90 },
    { odds: 0.12, type: SpinWheelRewardType.CARDS_1, value: 1, angle: 0 },
    { odds: 0.07, type: SpinWheelRewardType.CARDS_2, value: 2, angle: 135 },
    { odds: 0.03, type: SpinWheelRewardType.CARDS_3, value: 3, angle: 270 },
    { odds: 0.1, type: SpinWheelRewardType.LIVES_1, value: 1, angle: 45 },
    { odds: 0.02, type: SpinWheelRewardType.LIVES_2, value: 2, angle: 180 },
];

export interface IGiftRewardData {
    odds: number;
    type: GameRewardType;
    value: number;
}

export const GIFT_REWARDS: IGiftRewardData[] = [
    { odds: 0.15, type: GameRewardType.LIVES, value: 1 },
    { odds: 0.33, type: GameRewardType.COINS, value: 80 },
    { odds: 0.19, type: GameRewardType.COINS, value: 90 },
    { odds: 0.1, type: GameRewardType.COINS, value: 100 },
    { odds: 0.11, type: GameRewardType.COINS, value: 110 },
    { odds: 0.12, type: GameRewardType.COINS, value: 120 },
];
